import { isNotUndefined } from "@faire/web/common/typescriptUtils";

import { IBrandShipping } from "@faire/retailer/stores/domain/CartStore/consts";

export const isShippingEstimateInfoValid = (brand: IBrandShipping) => {
  return (
    isNotUndefined(brand.lower_bound_lead_time_days) &&
    isNotUndefined(brand.upper_bound_lead_time_days) &&
    isNotUndefined(brand.shipping_time_lower_bound_days) &&
    isNotUndefined(brand.shipping_time_upper_bound_days)
  );
};
